// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1fDn6","tab":"Tabs_tab__1vQ_0","tabActive":"Tabs_tabActive__2SfWf"};